export default class DtoWaterTurnRestriction {
    constructor(obj) {
        this.id = obj.id // Option[Long],
        this.level = obj.level // Option[Int],
        this.label = obj.label // Option[String],
        this.description = obj.description // Option[String],
        this.comment = obj.comment // Option[String],
        this.color = obj.color // Option[String]
    }
}